<template>
  <div class="page">
    <div class="group_1">
      <div class="text_1">
        我的积分：<span style="font-size: 17px; font-weight: 600">{{ surplusIntegral }}</span>
      </div>
      <div class="btn_1" @click="gotoXuanke">获取更多积分</div>
    </div>
    <div class="group_2">
      <div class="text_2">
        <span class="text_3" :class="show ? 'active' : ''" @click="getInfo(1)">获得记录</span>
        <span class="text_3" :class="!show ? 'active' : ''" @click="getInfo(2)">使用记录</span>
      </div>
      <!-- 获得表格 -->
      <div class="obtainedTable" v-if="showObtained">
        <div class="context">
          <div class="title_1">
            <span style="text-align: left">获得类型</span>
            <span>获得时间</span>
            <span style="text-align: right">获得积分</span>
          </div>
          <div class="title_2" v-for="(item, index) in tableInfo" :key="index">
            <span style="text-align: left;">{{ item.INTEGRAL_ITEM }}</span>
            <span style="text-align: center;">{{ item.CREATETIME }}</span>
            <span style="text-align: right; color: #ff8833;">+{{ item.INTEGRAL }}分</span>
          </div>
        </div>
      </div>
      <!-- 使用表格 -->
      <div class="obtainedTable" v-if="showUse">
        <div class="context">
          <div class="title_1">
            <span style="text-align: left">兑换类型</span>
            <span>兑换时间</span>
            <span style="text-align: right">使用积分</span>
          </div>
          <div class="title_2" v-for="(item, index1) in tableInfo" :key="index1">
            <span style="text-align: left;">{{ item.INTEGRAL_ITEM }}</span>
            <span style="text-align: center;">{{ item.CREATETIME }}</span>
            <span  style="text-align: right; color: #ff8833;">-{{ item.INTEGRAL }}分</span>
          </div>
        </div>
      </div>
      <div class="context" v-if="tableInfo.length == 0">暂无数据~</div>
      <!-- 加载更多按钮 -->
      <div v-if="hasMore && tableInfo.length > 0" class="load-more" @click="loadMore">
        <span>点击加载更多</span>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { findIntIntegralList } from '../../api/my';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      show: true,
      pageNum: 1,
      pageSize:10,
      total: 0,
      tableInfo: [],
      surplusIntegral: 0,
      showObtained: true,
      showUse: false,
      loading: false, 
      hasMore: true, // 是否还有更多数据
      currentType: '01'
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    loadMore() {
      if (this.hasMore && !this.loading) {
        this.pageNum++;
        this.getIntegral();
      }
    },
    //去获取更多积分
    gotoXuanke() {
      this.$router.push({
        path: '/chooseClass'
      });
    },
    //按钮点击切换
    getInfo(index) {
      this.tableInfo = [];
      this.pageNum = 1;
      this.hasMore = true;
      if (index == 1) {
        this.currentType = '01';
        this.show = true;
        this.showUse = false;
        this.showObtained = true;
      } else {
        this.currentType = '02';
        this.show = false;
        this.showUse = true;
        this.showObtained = false;
      }
      this.getIntegral();
    },
    //获取我的积分列表
    getIntegral() {
      if (this.loading || !this.hasMore) return;
      this.loading = true;
      findIntIntegralList({
        type: this.currentType,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
        .then(res => {
          this.total =res.data.total;
          if (this.pageNum === 1) {
            this.tableInfo = res.data.rows;
          } else {
            this.tableInfo =[...this.tableInfo,...res.data.rows]
          }
          // 更新是否还有更多
          if (this.tableInfo.length >= res.data.total) {
            this.hasMore = false;
          }
          if (this.pageNum === 1) {
            this.surplusIntegral = res.data.data?.surplusIntegral || 0;
          }
        })
        .catch(err => {
          if (this.pageNum > 1) this.pageNum--; 
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getIntegral('01');
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
.page {
  padding: 10px 15px;
}
.group_1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 15px 8px;
  background: linear-gradient(111deg, #ff8833 0%, #ffb581 100%);
  border-radius: 8px 8px 8px 8px;
  .text_1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }
  .btn_1 {
    width: 92px;
    height: 28px;
    background: #ffffff;
    border-radius: 14px 14px 14px 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #ff8833;
    text-align: center;
    line-height: 28px;
  }
}
.group_2 {
  padding: 20px 15px;
  margin-top: 10px;
  width: 100%;
  height: auto;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  .text_2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #eeeeee;
  }
  .text_3 {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #666666;
  }
}
.active {
  font-weight: 500 !important;
  font-size: 15px;
  color: #ff8833 !important;
}
.context {
  font-weight: 400;
  font-size: 15px;
  color: #666666;
  text-align: center;
  margin-top: 20px;
}
.title_1 {
  display: flex;
  justify-content: space-between;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  width: 100%;
  span {
    width: 33%;
  }
}
.title_2 {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: rgba(153, 153, 153, 1);
  width: 100%;
 
}
.load-more {
  margin-top: 20px;
  text-align: center;
}
</style>
